// Small JSON helpers for the intake endpoints (contracts/intake-endpoints.md).
const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

async function request(method, url, body) {
    const response = await fetch(url, {
        method,
        credentials: 'same-origin',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken(),
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    let data = null;
    try {
        data = await response.json();
    } catch (e) {
        data = null;
    }
    return {ok: response.ok, status: response.status, data};
}

export const postJSON = (url, body) => request('POST', url, body);
export const getJSON = (url) => request('GET', url);

export const generationUrl = (dealUuid, action) =>
    `/deals/${encodeURIComponent(dealUuid)}/ai_generation${action ? `/${action}` : ''}`;

// Rails-style "%{name}" interpolation for strings passed from the server.
export const interpolate = (text, values = {}) =>
    String(text || '').replace(/%\{(\w+)\}/g, (_, key) => (values[key] ?? `%{${key}}`));
